var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChevronRightCollection(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 122,
    viewBox: "0 0 122 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 60.5,
    r: 60.5,
    transform: "rotate(90 60.5 60.5)",
    fill: "#222222"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.5535 83.5645L70.0741 68.5845C71.9521 66.407 73 63.5114 73 60.5C73 57.4886 71.9521 54.593 70.0741 52.4155L56.5535 37.4355C55.7237 36.5164 54.5983 36 53.4247 36C52.2512 36 51.1258 36.5164 50.296 37.4355C49.4662 38.3547 49 39.6014 49 40.9013C49 42.2012 49.4662 43.4478 50.296 44.367L63.8195 59.3469C64.096 59.6532 64.2512 60.0686 64.2512 60.5016C64.2512 60.9347 64.096 61.3501 63.8195 61.6563L50.296 76.633C49.4662 77.5522 49 78.7989 49 80.0987C49 81.3986 49.4662 82.6453 50.296 83.5645C51.1258 84.4836 52.2512 85 53.4247 85C54.5983 85 55.7237 84.4836 56.5535 83.5645Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightCollection);
export default __webpack_public_path__ + "static/media/chevron-right-collection.b19087e92d7628626b3850c913767962.svg";
export { ForwardRef as ReactComponent };